import React, { memo } from 'react'

import { func, number, string } from 'prop-types'

import CardFooter from '../CardFooter/CardFooter'
import SubscriptionBullets from '../SubscriptionBullets/SubscriptionBullets'

// Compact teal-tinted subscription upsell shared by the 3D Studio usage modal (via a store-adapter
// wrapper) and the AI subscription landing waitlist modal. All data is injected so the card stays
// store-agnostic.
function UpgradeCard({
  title = 'Upgrade to Keep Creating',
  price = null,
  originalPrice = null,
  monthlyModels = null,
  subscriptionHref,
  learnMoreHref = '#',
  onClose: handleClose,
}) {
  return (
    <section className="usage-modal__upgrade-card">
      <div className="usage-modal__upgrade-card-main">
        <div className="usage-modal__upgrade-card-header">
          <p className="cgt-heading-200">
            {title}
          </p>

          {price && (
            <div className="usage-modal__upgrade-card-price">
              <div className="usage-modal__upgrade-card-price-row">
                {originalPrice && (
                  <span className="usage-modal__upgrade-card-price-original cgt-body-lg-semibold">
                    {originalPrice}
                  </span>
                )}
                <span className="cgt-heading-300">{price}</span>
              </div>
              <span className="usage-modal__upgrade-card-price-unit cgt-caption-semibold">
                /month
              </span>
            </div>
          )}
        </div>

        <SubscriptionBullets variant="upgrade" monthlyModels={monthlyModels} />

        <CardFooter
          variant="upgrade"
          subscriptionHref={subscriptionHref}
          learnMoreHref={learnMoreHref}
          onClose={handleClose}
        />
      </div>
    </section>
  )
}

UpgradeCard.propTypes = {
  title: string,
  price: string,
  originalPrice: string,
  monthlyModels: number,
  subscriptionHref: string.isRequired,
  learnMoreHref: string,
  onClose: func.isRequired,
}

export default memo(UpgradeCard)
